if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });

        // Setup video play/pause controls if present in the same section
        const sectionEl = this.closest('.section--collapsible-tabs');
        if (sectionEl) {
          const controlBtn = sectionEl.querySelector('.video-playpause__controls .scrolling-promotion__control-btn');
          const pauseIcon = sectionEl.querySelector('.video-playpause__controls .scrolling-promotion__pause-icon');
          const playIcon = sectionEl.querySelector('.video-playpause__controls .scrolling-promotion__play-icon');
          const videoWrapper = sectionEl.querySelector('video-element');

          const bindControls = (video) => {
            if (!controlBtn || !video) return;

            const updateUI = () => {
              const isPaused = video.paused;
              if (controlBtn) {
                controlBtn.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
                controlBtn.classList.toggle('is-paused', isPaused);
              }
              if (pauseIcon) pauseIcon.style.display = isPaused ? 'none' : 'block';
              if (playIcon) playIcon.style.display = isPaused ? 'block' : 'none';
            };

            updateUI();

            controlBtn.addEventListener('click', () => {
              if (video.paused) {
                // Try to play; if blocked by browser policy, let native controls show
                video.play().catch(() => {});
              } else {
                video.pause();
              }
              // UI will update on next event loop but we also update immediately
              updateUI();
            });

            // Keep UI in sync with actual playback state
            video.addEventListener('play', updateUI);
            video.addEventListener('pause', updateUI);
            video.addEventListener('ended', updateUI);
          };

          if (videoWrapper) {
            // If content already stamped, find the <video>
            const existingVideo = videoWrapper.querySelector('video');
            if (existingVideo) {
              bindControls(existingVideo);
            } else {
              // Wait for the video-element to load its template content
              const observer = new MutationObserver(() => {
                const v = videoWrapper.querySelector('video');
                if (v) {
                  bindControls(v);
                  observer.disconnect();
                }
              });
              observer.observe(videoWrapper, { childList: true, subtree: true });
            }
          }
        }
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
